import React, {useState} from 'react';
import {Dialog} from "primereact/dialog";
import {useTranslate} from "../../system/useTranslate";
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {setMessage} from "../../system/app-slice";
import api from "../../system/api";
import Icon from "../../system/components/icon";
import {useNavigate} from "react-router-dom";
import useWorkspaceMembership from "../../models/workspace-membership/use-workspace-membership";
import useUserEventLog from "../../models/user-event-log/use-user-event-log";

function AcceptDenyNotificationDialog({visible, setVisible}) {
    const translate = useTranslate();
    const {config, notifications} = useSelector((state) => state.app);
    const currentItem = (notifications || []).find((item) => (
        !item.isRead && item.displayType === "accept-deny-dialog"
    ));

    return (
        <Dialog  className={`h-30rem w-11 lg:w-4 ${config.dir}`} header={translate("notifications")} onHide={()=>{setVisible(false)}} visible={visible && Boolean(currentItem)}>
            <div className="flex h-full border-1 border-300 border-round">
                <ItemContent currentItem={currentItem}/>
            </div>

        </Dialog>
    );
}

function ItemContent({currentItem}) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const workspaceMembership = useWorkspaceMembership();
    const userEventLog = useUserEventLog();
    const [submitting, setSubmitting] = useState(false);

    const markUserEventLogAsRead = async (responseState) => {
        const documentId = currentItem?.documentId || currentItem?.id;
        if (!documentId) return;
        await userEventLog.updateUserEventLog(documentId, {isRead: true, responseState});
    };

    const acceptWorkspaceInvite = async () => {
        const invitationData = currentItem?.audit_log?.after;
        const invitationId = currentItem?.payload?.invitationId || invitationData?.id;

        if (!invitationId) {
            dispatch(setMessage({severity: "error", content: translate("workspace-invitation.error.invalid-id")}));
            return;
        }

        setSubmitting(true);
        try {
            await api.post(`/accept-workspace-invitation`, {invitationId});
            await markUserEventLogAsRead("responded");
            await workspaceMembership.getWorkspaceMemberships();
            navigate("/");
        } catch (error) {
            dispatch(setMessage({
                severity: "error",
                content: translate(error?.message || "workspace-invitation.error.accept"),
            }));
        } finally {
            setSubmitting(false);
        }
    };

    const dismissWorkspaceInvite = async () => {
        setSubmitting(true);
        try {
            await markUserEventLogAsRead("dismissed");
        } catch (error) {
            dispatch(setMessage({
                severity: "error",
                content: translate(error?.message || "workspace-invitation.error.dismiss"),
            }));
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <div className="flex flex-column p-2 w-full">
            <span className="font-bold">{translate(currentItem?.title)}</span>
            <div className="flex-1 mt-3">
                {translate("you-invited-to-workspace-message")
                    .replace("{{INVITER}}", currentItem?.payload?.inviterName || currentItem?.audit_log?.after?.inviter?.member?.fullname || "---")
                    .replace("{{WORKSPACE}}", currentItem?.payload?.workspaceName || currentItem?.audit_log?.after?.workspace?.name || "---")}
                {/*<p>{currentItem?.data.message}</p>*/}
            </div>
            <div className="flex align-items-start gap-1">
                <Icon icon="mi mi:info" className="text-lg text-400"/>
                <span className="text-400 text-xs">{translate("invite-info")}</span>
            </div>
            <Footer loading={submitting} onAccept={acceptWorkspaceInvite} onCancel={dismissWorkspaceInvite}/>
        </div>
    )
}

function Footer({loading, onAccept, onCancel}){
    const translate = useTranslate();

    return(<div className="flex justify-content-end w-full gap-2">
        <Button className="p-button-success" label={translate("accept")} loading={loading} disabled={loading} onClick={onAccept}/>
        <Button className="p-button-secondary" label={translate("reject")} disabled={loading} onClick={onCancel}/>
    </div>)
}

export default AcceptDenyNotificationDialog;
